import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { ConfigUtil } from '../configUtils';
import { WindowHandleService } from 'src/app/services/window-handle.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(
    private sessionService: SessionService,
    private route: Router,
    private windowHandleService: WindowHandleService
  ){}

  canActivate(): boolean {
    if(!this.sessionService.currentUserValue){
      this.route.navigate(['/login']);
      this.windowHandleService.showTopBarBehavior.next(false);
    }
    return true;
  }
}
